function getJsBridge() {
  if (window.WeiboJSBridge) {
    return window.WeiboJSBridge;
  }
  return null;
}

function jsBridge(functionName, ...args) {
  const c = getJsBridge();
  if (!c) {
    document.addEventListener('WeiboJSBridgeReady', function() {
      getJsBridge()[functionName](...args);
    })
  } else {
    c[functionName](...args);
  }
}

export default jsBridge;
